namespace aq.ui {

    class _ActivityAidIssueDisplay {
        public noDataCallback: () => void;
        public contextLoadedCallback: () => void;
        public activity: aq.models.activity.ActivityResponse;
        public issue: aq.models.aidIssue.IssueResponse;
        public isLoading: boolean;
        private building: aq.common.models.Building;
        private accountId: number;
        private account: aq.common.models.Account;

        /* @ngInject */
        constructor(
            private $scope: ng.IScope,
            private $translate,
            private Restangular: restangular.IService,
            private resolver: aq.services.Resolver,
            private Messages: aq.services.Messages,
            private AidIssueService: aq.services.AidIssueService
        ) {
        }

        public $onInit() {
            this.isLoading = true;
            this.resolver(async () => {
                try {
                    const issuePromise = this.AidIssueService.getIssue(this.activity.context.aidissue);
                    const accountPromise = this.Restangular.one('accounts', this.accountId).get({ single: true });
                    [this.issue, this.account] = await Promise.all([issuePromise, accountPromise]);
                    this.isLoading = false;
                    this.contextLoadedCallback();
                    this.$scope.$emit('ActivityContextLoaded', this.issue);
                } catch (err) {
                    this.isLoading = false;
                    this.noDataCallback();
                    this.Messages.error('Data failed to load');
                    throw err;
                }
            });
        }
    }

    export const ActivityAidIssueDisplay: ng.IComponentOptions = {
        controller: _ActivityAidIssueDisplay,
        controllerAs: 'vm',
        templateUrl: 'app/common/components/activities/contexts/aidIssueDisplay.html',
        bindings: {
            activity: '<',
            accountId: '<',
            building: '<',
            noDataCallback: '&',
            contextLoadedCallback: '&'
        }
    };

    angular
        .module('aq.ui')
        .component('activityAidIssueDisplay', ActivityAidIssueDisplay);
}
